import * as React from "react";

const Currency = (props: any) => (
  <svg width={20} height={20} viewBox="0 0 20 20" {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h20v20H0z" />
      <path
        d="M9.905 6.766c-.432 0-.766.09-1.002.27-.236.18-.354.482-.354.906 0 .192.04.356.12.492.08.136.182.252.306.348.124.096.268.174.432.234.164.06.33.11.498.15v-2.4zm-1.536 5.088c-.008.528.108.944.348 1.248.24.304.636.464 1.188.48v-2.904a9.945 9.945 0 0 1-.978-.318 3.559 3.559 0 0 1-.876-.48 2.252 2.252 0 0 1-.63-.738c-.16-.296-.24-.664-.24-1.104 0-.384.074-.722.222-1.014a2.14 2.14 0 0 1 .6-.732c.252-.196.542-.346.87-.45a3.394 3.394 0 0 1 1.032-.156V4.75h.516v.936c.36 0 .7.048 1.02.144.32.096.598.24.834.432s.424.436.564.732c.14.296.21.64.21 1.032H11.68c-.016-.408-.122-.72-.318-.936-.196-.216-.51-.324-.942-.324v2.532c.36.096.712.208 1.056.336.344.128.648.292.912.492s.476.448.636.744c.16.296.24.66.24 1.092 0 .448-.074.838-.222 1.17-.148.332-.35.608-.606.828-.256.22-.556.388-.9.504a3.974 3.974 0 0 1-1.116.198v.936h-.516v-.936a3.733 3.733 0 0 1-1.188-.204 2.658 2.658 0 0 1-.924-.546 2.39 2.39 0 0 1-.594-.87A2.988 2.988 0 0 1 7 11.854h1.368zm2.052 1.728c.432-.032.786-.158 1.062-.378s.414-.57.414-1.05c0-.224-.042-.412-.126-.564a1.19 1.19 0 0 0-.336-.384 1.849 1.849 0 0 0-.474-.252 6.042 6.042 0 0 0-.54-.168v2.796z"
        fill="#7B838C"
      />
    </g>
  </svg>
);

export default Currency;

